<template lang="pug">
md-input-container
  label(for='pricingUnit') Pricing Unit
  md-select#pricingUnit(v-model='selected', @selected='onPricingUnitSelected')
    md-option(value='cpm') CPM
</template>

<script>
  export default {
    props: {
      value: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        selected: this.value
      };
    },
    methods: {
      onPricingUnitSelected(value) {
        this.$emit('input', value);
      }
    },
    watch: {
      value(newValue) {
        if (newValue) {
          this.selected = newValue;
        }
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/shared-components/pricing/PricingUnitSelector.vue